import { ComplexCommonResponseBody } from "../../api/UnitManagement";
import { Classifier } from "../../util/classifierManager";
import { FormattedDecimal } from "../../util/conversionUtils";
import { LastEdited } from "./managementTypes/StageTypes";

export enum TabNames {
  andmetabel = "andmetabel",
  investeeringuprojekt = "investeeringuprojekt",
  investeeringutaotlus = "investeeringutaotlus",
}

export function getTabNames() {
  return Object.keys(TabNames) as (keyof typeof TabNames)[];
}

export function getTabNamesForKvy() {
  return Object.keys(TabNames).filter((r) => r == TabNames.andmetabel) as (keyof typeof TabNames)[];
}

export const TabNameToTitleKey = new Map<string, string>([
  [TabNames.andmetabel, "datatable"],
  [TabNames.investeeringuprojekt, "investmentProject"],
  [TabNames.investeeringutaotlus, "investmentApplication"],
]);

export interface ComplexCommonData
  extends Omit<
    ComplexCommonResponseBody,
    | "valitsejaId"
    | "valitsejaNimi"
    | "volitatudAsutusId"
    | "volitatudAsutusNimi"
    | "hoonestatudYyripnnaSumma"
    | "kasutusele"
    | "loovutamine"
    | "ipKirjed"
    | "esmaneAktiveerimine"
  > {
  onPkvy: boolean;
  kood: string;
  nimetus?: string;
  aadress?: string;
  valitseja?: Classifier;
  volitatudAsutus?: Classifier;
  since: string;
  sinceYear: string;
  until: string;
  untilYear: string;
  firstVersionDate?: string;
  firstVersionYear?: string;
  hoonestatudYyripnnaSumma?: FormattedDecimal;
  ipKirjed: InvestmentPorjectVersionData[];
}

export interface ComplexActivePeriod {
  since: number;
  until: number;
}

export interface InvestmentPorjectVersionData {
  id: number;
  nr?: number;
  staatus?: Classifier;
}
export interface InvestmentApplicationData {
  id: number;
  kood: string;
  vastavaksTunnistamine?: string;
  esitamine?: string;
  staatus: string;
  taotletavOtsus?: string;
  otsuseStaatus?: string;
  pdfId?: number;
  pdfName?: string;
  lastEdit?: LastEdited;
}
